/**
 * Writes whose contract declares the required `Idempotency-Key` header (common.yaml#IdempotencyKey).
 * Keyed as "METHOD /path/template". tests/contract-sync.test.ts checks this list against
 * ../contracts/openapi.yaml so it cannot drift. Crew, owner and phone writes are listed too: the client must never
 * send one of them without a key, even though this staff module does not call them.
 */
export const IDEMPOTENT_OPERATIONS: ReadonlySet<string> = new Set([
  "POST /fer/v1/alerts",
  "POST /fer/v1/alerts/{alert_id}/location-links",
  "POST /fer/v1/alerts/{alert_id}/confirmation",
  "POST /fer/v1/incidents/{incident_id}/dispatches",
  "POST /fer/v1/me/bookings",
  "POST /fer/v1/stations",
  "POST /fer/v1/appliances",
  "POST /fer/v1/station-assignments",
  "POST /fer/v1/premises",
  "POST /fer/v1/premises/{premises_id}/risk-class",
  "POST /fer/v1/premises/{premises_id}/occupancy",
  "POST /fer/v1/premises/{premises_id}/owner",
  "POST /fer/v1/certificate-applications",
  "POST /fer/v1/certificate-applications/{application_id}/checkout",
  "POST /fer/v1/certificate-applications/{application_id}/withdrawal",
  "POST /fer/v1/certificate-applications/{application_id}/bill-cancellation",
  "POST /fer/v1/certificate-applications/{application_id}/reinspection-request",
  "POST /fer/v1/inspections",
  "POST /fer/v1/certificates/{certificate_id}/revocation",
  "POST /fer/v1/hydrants",
  "POST /fer/v1/hydrants/{hydrant_id}/surveys",
  "POST /fer/v1/uploads",
]);

export function requiresIdempotencyKey(method: string, pathTemplate: string): boolean {
  return IDEMPOTENT_OPERATIONS.has(`${method.toUpperCase()} ${pathTemplate}`);
}

export function newIdempotencyKey(): string {
  const c = globalThis.crypto;
  if (c && typeof c.randomUUID === "function") return c.randomUUID();
  // Fallback for very old runtimes: RFC 4122 v4 from getRandomValues.
  const b = new Uint8Array(16);
  c.getRandomValues(b);
  b[6] = (b[6] & 0x0f) | 0x40;
  b[8] = (b[8] & 0x3f) | 0x80;
  const h = Array.from(b, (x) => x.toString(16).padStart(2, "0")).join("");
  return `${h.slice(0, 8)}-${h.slice(8, 12)}-${h.slice(12, 16)}-${h.slice(16, 20)}-${h.slice(20)}`;
}

/** A console-generated `client_id` (8-64 characters) for creates the contract dedupes on it (`createAlert`). */
export function newClientId(prefix = "console"): string {
  return `${prefix}-${newIdempotencyKey()}`;
}
